import { Product } from '../../types';

export const specialSeriesProducts: Product[] = [
  {
    id: "bt-special-swt099001",
    name: "Special Series Terminal - 7.7 Female (SWT099001)",
    slug: "special-series-terminal-7-7-female-swt099001",
    category: "Brass Terminal",
    subcategory: "Special Series",
    description: "7.7mm female spade terminal for standard applications. High conductivity brass construction.",
    partNumber: "SWT099001",
    specifications: {
      "Tab Size Ø": "9.10 mm",
      "Cable Size SQ. MM": "3.00-4.00",
      "Description": "7.7 Female",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-1500 Cut-1000",
    },
    images: ["/products/brass-terminals/special-series/SWT099001.jpg"],
    tags: ["terminal", "special", "brass", "female", "7.7mm"],
    applications: ["Automotive", "General Purpose"],
  },
  {
    id: "bt-special-swt099002",
    name: "Special Series Terminal - 7.7 Female (SWT099002)",
    slug: "special-series-terminal-7-7-female-swt099002",
    category: "Brass Terminal",
    subcategory: "Special Series",
    description: "7.7mm female spade terminal variant. High conductivity brass construction.",
    partNumber: "SWT099002",
    specifications: {
      "Tab Size Ø": "9.10 mm",
      "Cable Size SQ. MM": "3.00-4.00",
      "Description": "7.7 Female",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-1500 Cut-1000",
    },
    images: ["/products/brass-terminals/special-series/SWT099002.jpg"],
    tags: ["terminal", "special", "brass", "female", "7.7mm"],
    applications: ["Automotive", "General Purpose"],
  },
  {
    id: "bt-special-swt099003",
    name: "Special Series Terminal - 7.7 Male (SWT099003)",
    slug: "special-series-terminal-7-7-male-swt099003",
    category: "Brass Terminal",
    subcategory: "Special Series",
    description: "7.7mm male bullet terminal. Cylindrical design for secure connections.",
    partNumber: "SWT099003",
    specifications: {
      "Tab Size Ø": "7.80 mm",
      "Cable Size SQ. MM": "3.00-4.00",
      "Description": "7.7 Male",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-1500 Cut-1000",
    },
    images: ["/products/brass-terminals/special-series/SWT099003.jpg"],
    tags: ["terminal", "special", "brass", "male", "bullet", "7.7mm"],
    applications: ["Automotive", "General Purpose"],
  },
  {
    id: "bt-special-swt099008",
    name: "Special Series Terminal - 6.4 Positive Lock (SWT099008)",
    slug: "special-series-terminal-6-4-positive-lock-swt099008",
    category: "Brass Terminal",
    subcategory: "Special Series",
    description: "6.4mm female terminal with positive locking mechanism for secure connections.",
    partNumber: "SWT099008",
    specifications: {
      "Tab Size Ø": "6.40 mm",
      "Cable Size SQ. MM": "1.50-2.50",
      "Description": "6.4 Positive Lock",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-1250 Cut-1000",
    },
    images: ["/products/brass-terminals/special-series/SWT099008.jpg"],
    tags: ["terminal", "special", "brass", "female", "positive lock", "6.4mm"],
    applications: ["Automotive", "Secure Connections"],
  },
  {
    id: "bt-special-swt099012",
    name: "Special Series Terminal - 2.2 Female Box Terminal (SWT099012)",
    slug: "special-series-terminal-2-2-female-box-terminal-swt099012",
    category: "Brass Terminal",
    subcategory: "Special Series",
    description: "2.2mm female box terminal for compact applications. High conductivity brass construction.",
    partNumber: "SWT099012",
    specifications: {
      "Tab Size Ø": "2.20 mm",
      "Cable Size SQ. MM": "1.50-2.50",
      "Description": "2.2 Female Box Terminal",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-2500 Cut-1000",
    },
    images: ["/products/brass-terminals/special-series/SWT099012.jpg"],
    tags: ["terminal", "special", "brass", "female", "box", "2.2mm"],
    applications: ["Automotive", "Compact Applications"],
  },
  {
    id: "bt-special-swt099023",
    name: "Special Series Terminal - Sensor Terminal Male (SWT099023)",
    slug: "special-series-terminal-sensor-terminal-male-swt099023",
    category: "Brass Terminal",
    subcategory: "Special Series",
    description: "Male sensor terminal with narrow pin design. Ideal for sensor applications.",
    partNumber: "SWT099023",
    specifications: {
      "Tab Size Ø": "0.80 mm",
      "Cable Size SQ. MM": "1.20-2.20",
      "Description": "Sensor Terminal Male",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3000 Cut-1000",
    },
    images: ["/products/brass-terminals/special-series/SWT099023.jpg"],
    tags: ["terminal", "special", "brass", "male", "sensor", "0.8mm"],
    applications: ["Automotive", "Sensor Applications"],
  },
  {
    id: "bt-special-swt099025",
    name: "Special Series Terminal - 2.2 Double Side Lock Female (SWT099025)",
    slug: "special-series-terminal-2-2-double-side-lock-female-swt099025",
    category: "Brass Terminal",
    subcategory: "Special Series",
    description: "2.2mm female terminal with double side locking mechanism for enhanced security.",
    partNumber: "SWT099025",
    specifications: {
      "Tab Size Ø": "2.20 mm",
      "Cable Size SQ. MM": "0.80-1.80",
      "Description": "2.2 Double Side Lock Female",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3500 Cut-1000",
    },
    images: ["/products/brass-terminals/special-series/SWT099025.jpg"],
    tags: ["terminal", "special", "brass", "female", "double side lock", "2.2mm"],
    applications: ["Automotive", "Secure Connections"],
  },
  {
    id: "bt-special-swt099026",
    name: "Special Series Terminal - 2.2 Double Side Lock (SWT099026)",
    slug: "special-series-terminal-2-2-double-side-lock-swt099026",
    category: "Brass Terminal",
    subcategory: "Special Series",
    description: "2.2mm double side lock terminal with ribbed design. Enhanced locking mechanism.",
    partNumber: "SWT099026",
    specifications: {
      "Tab Size Ø": "2.40 mm",
      "Cable Size SQ. MM": "0.80-1.80",
      "Description": "2.2 Double Side Lock",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3500 Cut-1000",
    },
    images: ["/products/brass-terminals/special-series/SWT099026.jpg"],
    tags: ["terminal", "special", "brass", "double side lock", "2.2mm"],
    applications: ["Automotive", "Secure Connections"],
  },
  {
    id: "bt-special-swt099027",
    name: "Special Series Terminal - 1.8 Superseal Female (SWT099027)",
    slug: "special-series-terminal-1-8-superseal-female-swt099027",
    category: "Brass Terminal",
    subcategory: "Special Series",
    description: "1.8mm superseal female terminal with enhanced sealing properties.",
    partNumber: "SWT099027",
    specifications: {
      "Tab Size Ø": "1.80 mm",
      "Cable Size SQ. MM": "0.50-1.80",
      "Description": "1.8 Superseal Female",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3500 Cut-1000",
    },
    images: ["/products/brass-terminals/special-series/SWT099027.jpg"],
    tags: ["terminal", "special", "brass", "female", "superseal", "1.8mm"],
    applications: ["Automotive", "Sealed Applications"],
  },
  {
    id: "bt-special-swt099035",
    name: "Special Series Terminal - 2.2 Shutter Folding Terminal (SWT099035)",
    slug: "special-series-terminal-2-2-shutter-folding-terminal-swt099035",
    category: "Brass Terminal",
    subcategory: "Special Series",
    description: "2.2mm shutter folding terminal with protective shutter mechanism.",
    partNumber: "SWT099035",
    specifications: {
      "Tab Size Ø": "N/A",
      "Cable Size SQ. MM": "1.50-2.50",
      "Description": "2.2 Shutter Folding Terminal",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/special-series/SWT099035.jpg"],
    tags: ["terminal", "special", "brass", "shutter", "folding", "2.2mm"],
    applications: ["Automotive", "Protected Connections"],
  },
  {
    id: "bt-special-swt099053",
    name: "Special Series Terminal - 1.8 Superseal Male (SWT099053)",
    slug: "special-series-terminal-1-8-superseal-male-swt099053",
    category: "Brass Terminal",
    subcategory: "Special Series",
    description: "1.8mm superseal male terminal with enhanced sealing properties.",
    partNumber: "SWT099053",
    specifications: {
      "Tab Size Ø": "1.80 mm",
      "Cable Size SQ. MM": "0.50-1.80",
      "Description": "1.8 Superseal Male",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3500 Cut-1000",
    },
    images: ["/products/brass-terminals/special-series/SWT099053.jpg"],
    tags: ["terminal", "special", "brass", "male", "superseal", "1.8mm"],
    applications: ["Automotive", "Sealed Applications"],
  },
  {
    id: "bt-special-swt099054",
    name: "Special Series Terminal - Bulb Holder Terminal (SWT099054)",
    slug: "special-series-terminal-bulb-holder-terminal-swt099054",
    category: "Brass Terminal",
    subcategory: "Special Series",
    description: "Bulb holder terminal for automotive lighting applications. Compact design.",
    partNumber: "SWT099054",
    specifications: {
      "Tab Size Ø": "0.50 mm",
      "Cable Size SQ. MM": "0.80-1.90",
      "Description": "Bulb Holder Terminal",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-10000 Cut-1000",
    },
    images: ["/products/brass-terminals/special-series/SWT099054.jpg"],
    tags: ["terminal", "special", "brass", "bulb holder", "lighting"],
    applications: ["Automotive", "Lighting Applications"],
  },
  {
    id: "bt-special-swt099059",
    name: "Special Series Terminal - Bulb Holder Terminal With Hole (SWT099059)",
    slug: "special-series-terminal-bulb-holder-terminal-with-hole-swt099059",
    category: "Brass Terminal",
    subcategory: "Special Series",
    description: "Bulb holder terminal with hole for automotive lighting applications. Enhanced mounting option.",
    partNumber: "SWT099059",
    specifications: {
      "Tab Size Ø": "0.50 mm",
      "Cable Size SQ. MM": "0.80-1.90",
      "Description": "Bulb Holder Terminal With Hole",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-10000 Cut-1000",
    },
    images: ["/products/brass-terminals/special-series/SWT099059.jpg"],
    tags: ["terminal", "special", "brass", "bulb holder", "lighting", "with hole"],
    applications: ["Automotive", "Lighting Applications"],
  },
  {
    id: "bt-special-swt099161",
    name: "Special Series Terminal - 2.2 Female Dimple (SWT099161)",
    slug: "special-series-terminal-2-2-female-dimple-swt099161",
    category: "Brass Terminal",
    subcategory: "Special Series",
    description: "2.2mm female dimple terminal with distinctive dimple design for secure connections.",
    partNumber: "SWT099161",
    specifications: {
      "Tab Size Ø": "2.20 mm",
      "Cable Size SQ. MM": "1.50-2.30",
      "Description": "2.2 Female Dimple",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-10000 Cut-1000",
    },
    images: ["/products/brass-terminals/special-series/SWT099161.jpg"],
    tags: ["terminal", "special", "brass", "female", "dimple", "2.2mm"],
    applications: ["Automotive", "General Purpose"],
  },
  {
    id: "bt-special-swt099162",
    name: "Special Series Terminal - 2.2 Male Dimple (SWT099162)",
    slug: "special-series-terminal-2-2-male-dimple-swt099162",
    category: "Brass Terminal",
    subcategory: "Special Series",
    description: "2.2mm male dimple terminal with distinctive dimple design for secure connections.",
    partNumber: "SWT099162",
    specifications: {
      "Tab Size Ø": "2.20 mm",
      "Cable Size SQ. MM": "1.50-2.30",
      "Description": "2.2 Male Dimple",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-10000 Cut-1000",
    },
    images: ["/products/brass-terminals/special-series/SWT099162.jpg"],
    tags: ["terminal", "special", "brass", "male", "dimple", "2.2mm"],
    applications: ["Automotive", "General Purpose"],
  },
];
